import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

function CreaDeclaracion({ idSolicitud, onCreated }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const abrirModal = () => {
    setError("");
    setModalIsOpen(true);
  };

  const cerrarModal = () => {
    if (loading) return;

    setModalIsOpen(false);
    setArchivos([]);
    setError("");
  };

  const handleArchivo = (event) => {
    const archivosSeleccionados = Array.from(event.target.files || []);

    setArchivos(archivosSeleccionados);
    setError("");
  };

  const insertarArchivos = async (event) => {
    event.preventDefault();

    if (!idSolicitud) {
      setError("No se encontró el ID de la solicitud.");
      return;
    }

    if (archivos.length === 0) {
      setError("Debe adjuntar al menos un documento.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const formData = new FormData();

      archivos.forEach((archivo) => {
        formData.append("files", archivo);
      });

      const response = await axios.post(
        `${API_URL}/ArchivoDeclaracionCompromiso`,
        formData,
        {
          auth: AUTH,
          params: {
            IdSolicitud: idSolicitud,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Declaración creada:", response.data);

      // Actualizar tabla inmediatamente
      if (typeof onCreated === "function") {
        await onCreated();
      }

      cerrarModal();

      alert("Documento cargado correctamente.");
    } catch (error) {
      console.error("Error al cargar declaración:", error);

      const mensaje =
        error?.response?.data?.message || "No fue posible cargar el documento.";

      setError(mensaje);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-3">
        Adjunte el documento que declara el compromiso por parte del
        Representante Legal. Descárguelo de la biblioteca de documentos y
        anéxelo escaneado con la firma del Representante Legal.
      </div>

      <a
        href="../FORMATOSOLICITUD.pdf"
        download
        className="btn btn-outline-secondary mr-2"
      >
        Descargar Formato
      </a>

      <button type="button" className="btn btn-primary" onClick={abrirModal}>
        Adjuntar Documento
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Crear Declaración"
        ariaHideApp={false}
        shouldCloseOnOverlayClick={!loading}
        shouldCloseOnEsc={!loading}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "700px",
            maxHeight: "90vh",
            padding: "0",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
          },
        }}
      >
        <div className="card shadow mb-0">
          <div className="card-header py-3 d-flex justify-content-between align-items-center">
            <h6 className="m-0 font-weight-bold text-primary">
              Subir Declaración de Compromiso
            </h6>

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={cerrarModal}
              disabled={loading}
            >
              ×
            </button>
          </div>

          <div className="card-body">
            <form onSubmit={insertarArchivos}>
              {error && <div className="alert alert-danger">{error}</div>}

              <div className="form-group">
                <label
                  htmlFor="archivoDeclaracion"
                  className="font-weight-bold"
                >
                  Documento firmado
                </label>

                <input
                  id="archivoDeclaracion"
                  type="file"
                  className="form-control-file"
                  multiple
                  onChange={handleArchivo}
                  disabled={loading}
                />
              </div>

              {archivos.length > 0 && (
                <div className="alert alert-info">
                  <strong>{archivos.length}</strong> archivo
                  {archivos.length !== 1 ? "s" : ""} seleccionado
                  {archivos.length !== 1 ? "s" : ""}.
                </div>
              )}

              <hr />

              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={cerrarModal}
                  disabled={loading}
                >
                  Cancelar
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || archivos.length === 0}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                      />
                      Cargando...
                    </>
                  ) : (
                    "Guardar Documento"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaDeclaracion;
